export class EnumSymbol {
  sym = Symbol.for(name);
  value;
  description;

  constructor(name, {value, description}) {
    if(!Object.is(value, undefined)) this.value  = value;
    if(description) this.description  = description;

    Object.freeze(this);
  }

  get display() {
    return this.description || Symbol.keyFor(this.sym);
  }

  toString() {
    return this.sym;
  }

  valueOf() {
    return this.value;
  }
}

export class Enum {
  constructor(enumLiterals) {
    for (let key in enumLiterals) {
      if(!enumLiterals[key]) throw new TypeError('each enum should have been initialized with atleast empty {} value');
      this[key] = new EnumSymbol(key, enumLiterals[key]);
    }
    Object.freeze(this);
  }

  /*symbols() {
    return [for (key of Object.keys(this)) this[key] ];
  }*/

  keys() {
    return Object.keys(this);
  }

  contains(sym) {
    if (!(sym instanceof EnumSymbol)) return false;
    return this[Symbol.keyFor(sym.sym)] === sym;
  }
}

export const DistributionMethod = new Enum({
  CustomRanges: {value:	0, description:	"Creates user-defined bins"},
  EqualCountPerRange: {value: 1, description: "Creates bins so that there are approximately the same number of rows in each one"},
  EqualRangeSize:	{value: 2, description: "Creates bins such that each one covers an equal portion of the spectrum of values (for example, 0-25, 25-50, 50-75, 75-100)"},
  NaturalBreak:	{value: 3, description: "Creates bins using the natural breaks in the set of data values"},
  StandardDeviation: {value: 4, description:	"Create bins so that the middle bin ends at the mean of the data values, and the ranges above and below the middle range are one standard deviation above or below the mean. The population standard deviation (N - 1) is used here"},
  BIQuantile: {value: 5, description:	"Creates bins using a secondary quantiling variable, usually population"}
});

export const DotDensitySize = new Enum({
  Small: {value: 0, description: 'Defines small dot size'},
  Large: {value: 1, description: 'Defines large dot size'}
});
